import type { BrowserPort } from '../types';

export function createWebBrowser(win: Window = window): BrowserPort {
  return {
    openExternal: (url) => {
      win.open(url, '_blank', 'noopener,noreferrer');
    },
  };
}
